module.exports = "/_next/static/images/0904b2826291b961d30cf22d2e5ceecc-holding-device-smile@1x.jpg";